import {Bar} from 'vue-chartjs'

export default {
    extends: Bar,
    data() {
        return {
            query: '',
            stop: false,
            options: {
                responsive: true,
                maintainAspectRatio: false,
                showTooltips: false,
                showInlineValues: true,
                centeredInllineValues: true,
                scales: {
                    xAxes: [{
                        stacked: true,
                        categoryPercentage: 0.5,
                        barPercentage: 1
                    }],
                    yAxes: [{
                        stacked: true
                    }]
                }
            },
            delay: [],
            labels: []
        }
    },
    methods: {
        render() {
            this.renderChart({
                labels: this.labels,
                datasets: [
                    {
                        type: 'bar',
                        label: 'Count',
                        tooltipTemplate: 'ddd',
                        backgroundColor: '#49bd98',
                        data: this.delay,
                    }
                ]
            }, this.options);
        },
        init(data) {
            this.labels = [];
            this.delay = [];
            data.forEach(e => {
                this.labels.push(Number.parseInt(e.diff));
                this.delay.push(Number.parseInt(e.count));
            });
            this.render();
        }
    }
};